import { render, staticRenderFns } from "./DeleteAdminUserPopup.vue?vue&type=template&id=a0322f74"
import script from "./DeleteAdminUserPopup.vue?vue&type=script&lang=js"
export * from "./DeleteAdminUserPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports